/**
 * Feature Flag Constants
 * Centralized registry of all feature flags
 */

export const FEATURE_FLAGS = {
  AUTOMATION: 'automation',
  ADVANCED_ANALYTICS: 'advancedAnalytics',
  BETA_FEATURES: 'betaFeatures',
  NEW_UI: 'newUI',
} as const;

export type FeatureFlagName = typeof FEATURE_FLAGS[keyof typeof FEATURE_FLAGS];

export const DEFAULT_CONFIG = {
  enableDevTools: process.env.NODE_ENV === 'development',
  enableLogging: process.env.NODE_ENV === 'development',
  storageKey: 'ff_flags',
  urlPrefix: 'ff.',
};

export const PRIORITY_LEVELS = {
  URL: 100,
  BACKEND: 50,
  LOCAL_STORAGE: 25,
  DEFAULT: 0,
} as const;
